import type {serviceFunctionsRouteApi} from "./-route-api";
import type {z} from "zod";

import {listServiceFunctionsSearchSchema as applicationListServiceFunctionsSearchSchema} from "@project/application/engineering/service-functions";

export const listServiceFunctionsSearchSchema =
  applicationListServiceFunctionsSearchSchema.transform((search) => ({
    ...search,
    state: search.state === "DELETED" ? ("DELETED" as const) : ("ACTIVE" as const),
  }));

export type ListServiceFunctionsSearch = z.output<typeof listServiceFunctionsSearchSchema>;

export type ServiceFunctionsNavigateFn = ReturnType<typeof serviceFunctionsRouteApi.useNavigate>;
